"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.originalPriceStyles = void 0;
var _priceStyles = require("./priceStyles");
const originalPriceStyles = theme => ({
  ...(0, _priceStyles.priceStyles)(theme),
  color: theme.palette.grey.A700,
  marginRight: 0,
  textDecoration: 'line-through',
  whiteSpace: 'nowrap'
});
exports.originalPriceStyles = originalPriceStyles;